import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import exporting from 'highcharts/modules/exporting';

// Initialize exporting module
exporting(Highcharts);

const CallStatusBar = () => {
  // Define your data
  const periods = ['Daily', 'Weekly', 'Monthly', 'Quarterly'];
  const scheduledCalls = [100, 200, 300, 400];
  const completedCalls = [90, 180, 270, 360];

  const yAxisJson = {
    title: {
      text: ''
    }
  };

  const tooltipJson = {
    shared: true,
    valueSuffix: ' calls'
  };

  const columnData = [{
    name: 'Scheduled Calls',
    data: scheduledCalls,
    color: '#1279be' // Blue color
  }, {
    name: 'Completed Calls',
    data: completedCalls,
    color: '#74bd6d' // Red color
  }];

  const options6 = {
    chart: {
      type: 'column',
      height: 220,
      spacing: [0, 0, 0, 0],
      options3d: {
        enabled: true,
        alpha: 0,
        beta: 15,
        depth: 50,
        viewDistance: 25 // Adjusted viewDistance for better 3D effect
      }
    },
    title: {
      text: null,
      align: 'left',
      style: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#333',
        fontFamily: "IBM Plex Sans, sans-serif"
      }
    },
    xAxis: {
      categories: periods,
      gridLineWidth: 0
    },
    yAxis: yAxisJson,
    tooltip: tooltipJson,
    plotOptions: {
      column: {
        borderRadius: 20, // Set border radius for columns
        stacking: 'normal',
        dataLabels: {
          enabled: true,
          style: {
            textOutline: 'none'
          }
        }
      }
    },
    series: columnData,
    credits: {
      enabled: false
    },
    exporting: {
          enabled: true,
          buttons: {
            contextButton: {
              enabled: false
            }
          }
        },
    legend: {
      enabled: true
    }
  };

  return (
    <div>
      <HighchartsReact
        highcharts={Highcharts}
        options={options6}
      />
    </div>
  );
};

export default CallStatusBar;
